import React, { useState, useEffect, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { Timer as TimerIcon } from '@mui/icons-material';
import { AuthContext } from '../../contexts/AuthContext';

const SESSION_TIMEOUT = 10 * 60; // 10 minut w sekundach
const WARNING_TIME = 30; // 30 sekund

const SessionTimer = () => {
  const { logout } = useContext(AuthContext);
  const [timeLeft, setTimeLeft] = useState(SESSION_TIMEOUT);
  const [isWarning, setIsWarning] = useState(false);

  useEffect(() => {
    const tokenTimestamp = localStorage.getItem('tokenTimestamp');
    if (tokenTimestamp) {
      const expirationTime = new Date(parseInt(tokenTimestamp) + SESSION_TIMEOUT * 1000);
      const now = new Date();
      const difference = Math.floor((expirationTime - now) / 1000);
      setTimeLeft(difference > 0 ? difference : 0);
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          logout();
          return 0;
        }
        // Ustaw ostrzeżenie gdy zostanie 30 sekund
        if (prevTime <= WARNING_TIME && !isWarning) {
          setIsWarning(true);
        }
        return prevTime - 1;
      });
    }, 1000);

    // Reset timer on user activity
    const resetTimer = () => {
      setTimeLeft(SESSION_TIMEOUT);
      setIsWarning(false);
      localStorage.setItem('tokenTimestamp', Date.now().toString());
    };

    const handleActivity = () => {
      resetTimer();
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('scroll', handleActivity);
    window.addEventListener('touchstart', handleActivity);

    return () => {
      clearInterval(timer);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('touchstart', handleActivity);
    };
  }, [logout, isWarning]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center',
        color: isWarning ? 'error.main' : 'inherit',
        mr: 2
      }}
    >
      <TimerIcon sx={{ mr: 1 }} />
      <Typography variant="body2">
        Sesja wygaśnie za: {formatTime(timeLeft)}
      </Typography>
    </Box>
  );
};

export default SessionTimer;
